class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => {
      evt.code === "Escape" && this.close();
    });
    // window.addEventListener("popstate", (e) => {
    //   if (this.drawerOpen) {
    //     // window.history.pushState(null, null, '');
    //     this.close();
    //   }
    // });
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.drawerOpen = false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Clost cart drawer instead of going back , when pressing browser back button
    if (!this.drawerOpen) {
      window.history.pushState({ cartDrawer: true }, '');
      
      if (!this.popstateHandlerAdded) {
        window.addEventListener('popstate', () => {
          if (this.drawerOpen) {
            this.close();
          }
        });
        this.popstateHandlerAdded = true;
      }
      
      this.drawerOpen = true;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

    // free shipping progress bar animation
    const progressBarFill = this.querySelector(".progress-bar-fill");
    const progressBarFillOverlay = this.querySelector(
      ".progress-bar-fill-overlay"
    );
    const progressCheckpointGift = this.querySelector(".progress-bar-checkpoint.gift");
    const progressCheckpointShipping = this.querySelector(".progress-bar-checkpoint.shipping");
    progressCheckpointGift?.classList.remove("complete");
    progressCheckpointShipping?.classList.remove("complete");

    if (progressBarFill && progressBarFillOverlay) {
      progressBarFill.style.transitionDuration = "0s";
      progressBarFill.style.width = `0%`;
      progressBarFillOverlay.style.transitionDuration = "0s";
      progressBarFillOverlay.style.width = `0%`;
      progressBarFillOverlay.style.opacity = `100%`;
      
      const amountLeft = parseFloat(progressBarFill.dataset.amountLeft);

      // Skew progress bar to account for checkpoint spacing
      const progressPercentage = parseInt(progressBarFill.dataset.width);
      const displayedPercentage = amountLeft >= 400 ? progressPercentage * 0.95 : progressPercentage;

      setTimeout(() => {
        progressBarFill.style.transitionDuration = "2.5s";
        progressBarFill.style.width = `${displayedPercentage}%`;
        progressBarFillOverlay.style.transition =
          "width 2.5s ease, opacity 1s ease";
        progressBarFillOverlay.style.width = `${displayedPercentage}%`;
        progressBarFillOverlay.style.opacity = "0";
      }, 250);

      if (amountLeft <= 0) {
        setTimeout(
          () => (progressBarFill.style.animation = "1s linear both flash"),
          2750
        );
        setTimeout(() => (progressBarFill.style.animation = ""), 3750);
        setTimeout(() => {
          progressBarFillOverlay.animate(
            [
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              duration: 1000,
              easing: "ease",
              fill: "forwards",
            }
          );
          progressCheckpointGift?.classList.add("complete");
          progressCheckpointShipping?.classList.add("complete");
        }, 3750);
      } else {
        setTimeout(() => {
          progressBarFillOverlay.animate(
            [
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              duration: 1000,
              easing: "ease",
              fill: "forwards",
            }
          );
          if (amountLeft <= 2500) {
            progressCheckpointGift?.classList.remove("complete");
            progressCheckpointShipping?.classList.add("complete");
          } else {
            progressCheckpointGift?.classList.remove("complete");
            progressCheckpointShipping?.classList.remove("complete");
          }
        }, 2500);
      }

      setTimeout(() => {
        progressBarFill.style.transitionDuration = "";
        progressBarFillOverlay.style.transition = "";
      }, 2750);
    }

    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    this.drawerOpen = true;
    // window.history.pushState(null, null, "");
    const header = document.querySelector(".header-container");
    const scrollBarSize =
      window.innerWidth - document.documentElement.clientWidth;

    header.style.marginRight = `${scrollBarSize}px`;
    document.documentElement.style.marginRight = `${scrollBarSize}px`;
    document.body.classList.add("overflow-hidden");

    // Intercom('update', {
    //   "hide_default_launcher": true
    // });
  }

  close() {
    this.drawerOpen = false;
    // window.history.back();
    const header = document.querySelector(".header-container");
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    header.style.marginRight = "";
    document.documentElement.style.marginRight = "";
    document.body.classList.remove("overflow-hidden");
    const progressBarFill = document.querySelector(".progress-bar-fill");
    const progressBarFillOverlay = this.querySelector(".progress-bar-fill-overlay");
    const progressCheckpointGift = this.querySelector(".progress-bar-checkpoint.gift");
    const progressCheckpointShipping = this.querySelector(".progress-bar-checkpoint.shipping");

    if (progressBarFill) {
      setTimeout(
        () => (document.querySelector(".progress-bar-fill").style.width = "0%"),
        500
      );
      setTimeout(
        () => {
          progressBarFillOverlay.animate(
            [
              { opacity: "1" },
              { opacity: "0" },
            ],
            {
              duration: 100,
              easing: "ease",
              fill: "forwards",
            }
          );
          progressCheckpointGift?.classList.remove("complete");
          progressCheckpointShipping?.classList.remove("complete");
        }, 500
      );
    }

    // if (!isVisible || window.innerWidth > 780) {
    //   Intercom('update', {
    //     "hide_default_launcher": false
    //   }); 
    // }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
        if(sectionElement){
          sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        }
    });
    if (typeof injectTrialButton === "function") injectTrialButton();

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  // getSectionsToRender() {
  //   return [
  //     {
  //       id: 'CartDrawer',
  //       section: 'cart-drawer',
  //       selector: '.drawer__header',
  //     },
  //     {
  //       id: 'CartDrawer',
  //       section: 'cart-drawer',
  //       selector: '.drawer__body',
  //     },
  //     {
  //       id: 'CartDrawer',
  //       section: 'cart-drawer',
  //       selector: '.cart-drawer__footer',
  //     },
  //     {
  //       id: 'cart-icon-bubble',
  //       section: 'cart-icon-bubble',
  //       selector: '.shopify-section',
  //     },
  //   ];
  // }
}

customElements.define("cart-drawer-items", CartDrawerItems);
